import { IIconBase } from '..'

const changeStatusIcon = ({
  color = '#292D32',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/refresh-2'>
        <g id='refresh-2'>
          <path
            id='Vector'
            d='M14.6666 7.99992C14.6666 11.6799 11.6799 14.6666 7.99992 14.6666C4.31992 14.6666 2.07325 10.9599 2.07325 10.9599M2.07325 10.9599H5.08659M2.07325 10.9599V14.2933M1.33325 7.99992C1.33325 4.31992 4.29325 1.33325 7.99992 1.33325C12.4466 1.33325 14.6666 5.03992 14.6666 5.03992M14.6666 5.03992V1.70659M14.6666 5.03992H11.7066'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default changeStatusIcon
